import countries from '@/assets/json/countries.json'
export default {
  async  getCountriesList () {
    return countries.map((item) => {
      return {
        countryName: item.alpha2Code.toUpperCase() === 'GB' ? 'United Kingdom' : item.name,
        countryCode: item.alpha2Code,
        countryFlag: require(`@/assets/img/flags/countries/${item.alpha2Code.toLowerCase()}.svg`)
      }
    })
  }
}
